import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-flex;\n  vertical-align: bottom;\n  margin-right: 10px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  max-width: calc(100% - 150px);\n  background-color: ", ";\n  padding: 20px;\n  width: fit-content;\n  color: ", ";\n  border-radius: ", ";\n  font-size: 14px;\n  display: inline-flex;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: 10px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { AI_CHAT_MESSAGE } from './testIDs';
import avatar from './Avatar.png';
import Rating from './Rating';
var MessageContainerBox = styled.div(_templateObject());
var MessageContainer = styled.div(_templateObject2());
var InternalMessageBox = styled.div(_templateObject3(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.theme.borderRadius.large;
});
var AcornsImage = styled.img(_templateObject4());
export var ResponseMessage = function ResponseMessage(_ref) {
  var index = _ref.index,
      message = _ref.message,
      handleRateResponse = _ref.handleRateResponse;
  var showRating = Boolean(!message.isError && message.interactionId);
  return /*#__PURE__*/React.createElement(MessageContainerBox, {
    "data-testid": "".concat(AI_CHAT_MESSAGE, "_").concat(index)
  }, /*#__PURE__*/React.createElement(MessageContainer, null, /*#__PURE__*/React.createElement(AcornsImage, {
    src: avatar,
    alt: "squirrel"
  }), /*#__PURE__*/React.createElement(InternalMessageBox, {
    showRating: showRating
  }, message.text)), showRating && /*#__PURE__*/React.createElement(Rating, {
    rating: message.rating || 0,
    interactionId: message.interactionId,
    handleRateResponse: handleRateResponse
  }));
};